"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Y = __importStar(require("yjs"));
const util_1 = require("./util");
const peer_id_1 = __importDefault(require("peer-id"));
// @ts-ignore
const awarenessProtocol = __importStar(require("y-protocols/dist/awareness.cjs"));
function changesTopic(topic) {
    return `/marcopolo/gossipPad/${topic}/changes/0.0.01`;
}
function stateVectorTopic(topic) {
    return `/marcopolo/gossipPad/${topic}/stateVector/0.0.1`;
}
function syncProtocol(topic) {
    return `/marcopolo/gossipPad/${topic}/sync/0.0.1`;
}
function awarenessProtocolTopic(topic) {
    return `/marcopolo/gossipPad/${topic}/awareness/0.0.1`;
}
class Provider {
    constructor(ydoc, node, topic) {
        this.stateVectors = {};
        this.unsyncedPeers = new Set();
        this.initialSync = false;
        this.aggressivelyKeepPeersUpdated = true;
        this.ydoc = ydoc;
        this.node = node;
        this.topic = topic;
        this.peerID = this.node.peerId.toB58String();
        this.stateVectors[this.peerID] = Y.encodeStateVector(this.ydoc);
        this.awareness = new awarenessProtocol.Awareness(ydoc);
        this.awareness.setLocalStateField("user", {
            name: this.peerID
        });
        ydoc.on('update', this.onUpdate.bind(this));
        node.pubsub.subscribe(changesTopic(topic));
        node.pubsub.on(changesTopic(topic), this.onPubSubChanges.bind(this));
        node.pubsub.subscribe(stateVectorTopic(topic));
        node.pubsub.on(stateVectorTopic(topic), this.onPubSubStateVector.bind(this));
        node.pubsub.subscribe(awarenessProtocolTopic(topic));
        node.pubsub.on(awarenessProtocolTopic(topic), this.onPubSubAwareness.bind(this));
        // @ts-ignore
        node.handle(syncProtocol(topic), this.onSyncMsg.bind(this));
        this.tryInitialSync(this.stateVectors[this.peerID], this);
    }
    destroy() {
        this.node.pubsub.unsubscribe(changesTopic(this.topic));
        this.node.pubsub.removeAllListeners(changesTopic(this.topic));
        this.node.pubsub.unsubscribe(stateVectorTopic(this.topic));
        this.node.pubsub.removeAllListeners(stateVectorTopic(this.topic));
        this.node.pubsub.unsubscribe(awarenessProtocolTopic(this.topic));
        this.node.pubsub.removeAllListeners(awarenessProtocolTopic(this.topic));
        // @ts-ignore
        node.unhandle(syncProtocol(topic));
        this.initialSync = true;
    }
    // Not required, but nice if we can get synced against a peer sooner rather than latter
    tryInitialSync(updateData, origin) {
        return __awaiter(this, void 0, void 0, function* () {
            const tries = 10;
            const maxWaitTime = 1000;
            let waitTime = 100;
            for (let i = 0; i < tries; i++) {
                if (this.initialSync) {
                    return;
                }
                const peers = [...this.node.pubsub.topics.get(stateVectorTopic(this.topic)) || []];
                if (peers.length !== 0) {
                    const peer = peers[i % peers.length];
                    try {
                        yield this.syncPeer(peer);
                        this.initialSync = true;
                        return true;
                    }
                    catch (e) {
                        console.warn("failed to sync with anyone", e);
                    }
                }
                yield new Promise(resolve => setTimeout(resolve, waitTime));
                waitTime = Math.min(waitTime * 2, maxWaitTime);
            }
        });
    }
    onUpdate(updateData, origin) {
        if (origin !== this) {
            this.publishUpdate(updateData);
            return;
        }
    }
    publishUpdate(updateData) {
        if (!this.node.isStarted()) {
            return;
        }
        this.node.pubsub.publish(changesTopic(this.topic), updateData);
        const stateV = Y.encodeStateVector(this.ydoc);
        this.stateVectors[this.peerID] = stateV;
        this.node.pubsub.publish(stateVectorTopic(this.topic), stateV);
        // Publish awareness as well
        this.node.pubsub.publish(awarenessProtocolTopic(this.topic), awarenessProtocol.encodeAwarenessUpdate(this.awareness, [this.ydoc.clientID]));
    }
    onPubSubChanges(msg) {
        this.updateYdoc(msg.data, this);
    }
    onPubSubStateVector(msg) {
        this.stateVectors[msg.from] = msg.data;
        if (!(0, util_1.Uint8ArrayEquals)(msg.data, this.stateVectors[this.peerID])) {
            // Bookkeep that this peer is out of date
            // console.log("Peer is out of date", msg.from)
            this.queuePeerSync(msg.from);
        }
    }
    onPubSubAwareness(msg) {
        // console.log("Got awareness update", msg)
        awarenessProtocol.applyAwarenessUpdate(this.awareness, msg.data, this);
    }
    updateYdoc(updateData, origin) {
        this.initialSync = true;
        Y.applyUpdate(this.ydoc, updateData, this);
        this.stateVectors[this.peerID] = Y.encodeStateVector(this.ydoc);
    }
    storeStateVector(peerID, stateVector) {
        this.stateVectors[peerID] = stateVector;
    }
    fetchStateVector(peerID) {
        return this.stateVectors[peerID];
    }
    runSyncProtocol(stream, remotePeer, initiate) {
        return __awaiter(this, void 0, void 0, function* () {
            if (initiate) {
                yield stream.sink([
                    this.stateVectors[this.peerID],
                    Y.encodeStateAsUpdate(this.ydoc, this.stateVectors[remotePeer])
                ]);
            }
            const [{ value: stateVector }, { value: updateData }] = [
                yield stream.source[Symbol.asyncIterator]().next(),
                yield stream.source[Symbol.asyncIterator]().next()
            ];
            this.stateVectors[remotePeer] = stateVector.slice(0);
            this.updateYdoc(updateData.slice(0), this);
            if (!initiate) {
                yield stream.sink([
                    Y.encodeStateVector(this.ydoc),
                    Y.encodeStateAsUpdate(this.ydoc, this.stateVectors[remotePeer])
                ]);
            }
            stream.close();
        });
    }
    onSyncMsg(_a) {
        var { stream, connection } = _a, rest = __rest(_a, ["stream", "connection"]);
        return __awaiter(this, void 0, void 0, function* () {
            yield this.runSyncProtocol(stream, connection.remotePeer.toB58String(), false);
        });
    }
    queuePeerSync(peerID) {
        this.unsyncedPeers.add(peerID);
        if (this.aggressivelyKeepPeersUpdated) {
            for (const peerID of this.unsyncedPeers) {
                this.syncPeer(peerID).catch(console.error);
            }
        }
        else {
            throw new Error("Not implemented");
        }
    }
    syncPeer(peerID) {
        return __awaiter(this, void 0, void 0, function* () {
            const thiz = this;
            const multiaddrs = yield this.node.peerStore.addressBook.getMultiaddrsForPeer(peer_id_1.default.createFromB58String(peerID));
            let success = false;
            if (!multiaddrs) {
                return;
            }
            for (const ma of multiaddrs) {
                const maStr = ma.toString();
                try {
                    const { stream } = yield this.node.dialProtocol(maStr, syncProtocol(this.topic));
                    yield this.runSyncProtocol(stream, peerID, true);
                    success = true;
                    return;
                }
                catch (e) {
                    console.warn(`Failed to sync with ${maStr}`, e);
                    continue;
                }
            }
            throw new Error("Failed to sync with peer");
        });
    }
}
// TODO awareness
exports.default = Provider;
